<div class="{{localService.selectedLanguageCode}}">
  <app-popup-header
    title="{{header ? header :  (IsConfirmationType ? localService.languageContent.common.need_confirmation : localService.languageContent.common.message)}}">
  </app-popup-header>
  <app-message-box [IsHeaderVisible]="false" [IsYesPrimaryOnConfirmationType]="IsYesPrimaryOnConfirmationType"
    [message]="message" [IsHtmlMessage]="IsHtmlMessage" [IsConfirmationType]="IsConfirmationType" [header]="header"
    [customButtonText]="customButtonText" [timerValue]="timerValue"
    (onClose)="onCloseMessageBox($event)"></app-message-box>
</div>